<template>
    <v-card>
        <v-toolbar dark color="primary">
            <v-btn 
                icon 
                dark 
                :disabled="submitLoading" 
                @click="cancel">
                <v-icon large>close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title>
                <span v-if="editing">Edit Product Group</span>
                <span v-else>Add New Product Group</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-form ref="editForm" v-model="editValid">
            <v-layout class="dialog-content">
                <v-flex xs12 md6 offset-md3 mt-4>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-autocomplete
                                label="Product Category"
                                :items="availableCategories"
                                item-value="ProductCategoryID"
                                item-text="ProductCategoryName"
                                v-model="editData.productCategoryID" 
                                :rules="[
                                    rules.requiredNumber
                                ]">
                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field 
                                label="Product Group Name"
                                v-model="editData.productGroupName" 
                                :rules="[
                                    rules.required, 
                                    rules.maxTwoHundredCharacters
                                ]" 
                                counter >
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field 
                                label="Description"
                                v-model="editData.description" 
                                :rules="[
                                    rules.maxFiveHundredCharacters
                                ]">
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-checkbox 
                                label="Active"
                                v-model="editData.isActive">
                            </v-checkbox>
                        </v-flex>
                    </v-layout>
                    <v-layout wrap class="dialog-action-buttons">
                        <v-flex xs12 sm6>
                            <v-btn 
                                block 
                                color="success" 
                                :disabled="!editValid" 
                                :loading="submitLoading" 
                                @click="submit">
                                <span>Save</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12 sm6>
                            <v-btn 
                                block 
                                color="error" 
                                :disabled="submitLoading" 
                                @click="cancel">
                                <span>Cancel</span>
                            </v-btn>
                        </v-flex>
                        <v-flex xs12>
                            <v-alert 
                                :value="submitError != null" 
                                outline 
                                type="error">
                                <span>{{ submitError }}</span>
                            </v-alert>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-form>
    </v-card>
</template>

<script>
import validationRules from "@/helpers/validationrules";

export default {
    props: {
        availableCategories: {
            required: true,
            type: Array
        },
        data: {
            required: false,
            type: Object,
            default: null
        },
        submitLoading: {
            required: false,
            type: Boolean,
            default: false
        },
        submitError: {
            required: false,
            type: String,
            default: null
        }
    },
    data(){
        let data = this.data;
        if(data == null){
            data = {};
        }

        return {
            rules: validationRules.rules,
            editData: {
                id: data.ProductGroupID,
                productCategoryID: data.ProductCategoryID,
                productGroupName: data.ProductGroupName,
                description: data.Description,
                isActive: data.IsActive,
            },
            editValid: false
        }
    },
    computed: {
        editing(){
            return this.editData.id != null;
        }
    },
    methods: {
        cancel(){
            this.$emit("cancel");
        },
        submit(){
            this.$emit("submit", {
                ProductGroupID: this.editData.id,
                ProductCategoryID: this.editData.productCategoryID,
                ProductGroupName: this.editData.productGroupName,
                Description: this.editData.description,
                IsActive: this.editData.isActive
            });
        }
    }
}
</script>